export function byPageId(id) {
    return (page) => page.PageId === id;
}
